import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { CalculationService, DataService, DateService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { find } from 'lodash';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';

@Component({
  selector: 'app-part-add-inventory-dialog',
  templateUrl: './part-add-inventory-dialog.component.html',
  styleUrls: ['./part-add-inventory-dialog.component.scss'],
  providers: [DialogService],
})
export class PartAddInventoryDialogComponent implements OnInit {
  inventoryItem: any = {};
  actualItem: any = {};
  orderId: string = '';
  orderCode: string = '';
  orderStatus: string = '';
  usd: string = currency.USD;
  orderedItems: any[] = [];
  totalUsedQty: number = 0;
  totalOrderedQty: number = 0;
  dialogType: string = 'inventory';
  saveBtnLable: string = 'Add to inventory';
  cancelBtnLablel: string = 'Cancel';
  isSaving: boolean = false;
  isLoading: boolean = false;
  isMarkPartsDeliveredIndividuallyEnabled: boolean = false;
  estimate: any;
  adjustmentItem: any;

  constructor(
    private dateService: DateService,
    private dataService: DataService,
    private calculateService: CalculationService,
    private helperService: HelperService,
    private httpService: HTTPService,
    private dialogService: DialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit() {
    const { estimate, orderId, actualItem, associatedItem, dialogType } = this.dynamicDialogConfig.data;
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    const warehouseId = this.dataService.warehouse && this.dataService.warehouse.warehouseId;
    this.isMarkPartsDeliveredIndividuallyEnabled = this.dataService.isMarkPartsDeliveredIndividuallyEnabled;

    if (associatedItem) {
      this.inventoryItem = associatedItem;
      this.inventoryItem.totalCost = associatedItem?.cost * associatedItem?.count;
    }

    this.adjustmentItem = { ...actualItem };
    this.estimate = estimate;
    this.orderId = orderId;
    this.actualItem = actualItem;
    this.totalUsedQty = this.actualItem.count;
    this.dialogType = dialogType;

    if (this.inventoryItem) {
      this.inventoryItem.totalCost = this.inventoryItem.cost * this.inventoryItem.count;

      if (this.inventoryItem.locations && this.inventoryItem.locations.length) {
        if (isMultiLocationEnabled) {
          this.inventoryItem.location = find(this.inventoryItem.locations, { warehouseId });
        } else {
          this.inventoryItem.location = this.inventoryItem.locations[0];
        }
      }
    }

    if (this.dialogType === 'return') {
      this.saveBtnLable = 'Save';
    }

    if (this.actualItem) {
      this.getOrder();
    }
  }

  async getOrder() {
    try {
      this.isLoading = true;
      const order = await this.httpService.getEstimateById(this.orderId, true, false);
      const { manualQoutes, nexpartQoutes, partsTechQoutes, tireHubQoutes, tireConnectQoutes, repairLinkQoutes, speedDialQoutes } = this.helperService.formatOrderingQoutes(order);

      if (this.actualItem.isPopulateDynamically) {
        for (let i = 0; i < order.services.length; i++) {
          const { items = [] } = order.services[i];

          for (let j = 0; j < items.length; j++) {
            const item = items[j];

            if (this.actualItem._id === item._id) {
              this.actualItem = this.helperService.deepCopy(item);
              this.actualItem.totalCost = this.actualItem.cost * this.actualItem.count;
              this.inventoryItem.totalCost = this.actualItem.cost * this.actualItem.count;

              if (this.dialogType === 'return') {
                this.inventoryItem = this.actualItem;
              }
              break;
            }
          }
        }
      }

      // Manual Qoutes
      manualQoutes.forEach((manualQoute: any) => {
        manualQoute.qoute.orders.forEach((order: any) => {
          if (order.items && order.items.length) {
            order.items.forEach((manualOrderItem: any) => {
              let status = manualQoute.qoute.orderStatus;
              if (this.isMarkPartsDeliveredIndividuallyEnabled) {
                status = manualOrderItem?.itemStatus || manualQoute.qoute.orderStatus;
              }
              if (status === 'received' && this.actualItem._id === manualOrderItem.orderItemId) {
                const item = {
                  _id: manualOrderItem.orderItemId,
                  cartId: manualQoute.qouteId,
                  orderItemId: manualOrderItem.orderItemId,
                  itemId: manualOrderItem.itemId,
                  type: manualOrderItem.type,
                  title: manualOrderItem.title,
                  description: manualOrderItem.description,
                  code: manualOrderItem.code,
                  isTaxable: manualOrderItem.isTaxable,
                  // isTaxable: false,
                  price: manualOrderItem.price,
                  stocked: manualOrderItem.stocked,
                  supplier: manualQoute.qoute.supplier,
                  subTotal: manualQoute.qoute.subTotal,
                  supplierInvoicedNo: manualOrderItem?.supplierInvoicedNo ? manualOrderItem?.supplierInvoicedNo : manualQoute.qoute.supplierInvoicedNo ? manualQoute.qoute.supplierInvoicedNo : '',
                  cost: manualOrderItem.cost,
                  quantity: manualOrderItem.quantity,
                  usedQty: 0,
                  unUsedQty: 0,
                  qtyReturned: manualOrderItem.qtyReturned,
                  qtyAddedToInventory: manualOrderItem.qtyAddedToInventory,
                  totalCost: manualOrderItem.cost * manualOrderItem.quantity,
                  itemReturnQty: '' as string | number,
                  returnDate: new Date(),
                  itemSource: 'ManualOrder',
                  isConsumed: false,
                  poNumber: manualQoute.poNumber,
                };

                item.isConsumed = item.quantity === item.qtyReturned;

                this.totalOrderedQty += item.quantity;
                this.orderedItems.push(item);
              }
            });
          }
        });
      });

      // Nexpart Qoutes
      nexpartQoutes.forEach((nexpartQoute: any) => {
        if (nexpartQoute?.quote?.Cart?.BranchCart?.length) {
          nexpartQoute?.quote?.Cart?.BranchCart?.forEach((order: any) => {
            if (order.Parts && order.Parts.Part && order.Parts.Part.length) {
              order.Parts.Part.forEach((nexpartItem: any) => {
                nexpartItem.itemSourceId = [nexpartQoute.sessionId, order.SellerId, order.BranchId, nexpartItem.LineCode, nexpartItem.PartNumber].join('-');

                if (nexpartQoute.isOrderDelivered && nexpartItem.itemSourceId === this.actualItem.orderItemId && !nexpartItem.itemStatus) {
                  nexpartItem.itemStatus = 'received';
                }
                if (nexpartItem.itemSourceId === this.actualItem.orderItemId && nexpartItem.itemStatus === 'received') {
                  const item = {
                    cartId: nexpartQoute.sessionId,
                    orderItemId: nexpartItem.itemSourceId,
                    type: 'part',
                    title: nexpartItem.SellerPartDesc,
                    description: nexpartItem.CatalogPartDesc,
                    code: nexpartItem.PartNumber,
                    // isTaxable: this.adjustmentItem?.isTaxable || nexpartItem.isTaxable,
                    isTaxable: false,
                    price: Number(nexpartItem.List),
                    stocked: nexpartItem.stocked,
                    supplier: { name: order.Name },
                    subTotal: 0,
                    supplierInvoicedNo: nexpartItem?.supplierInvoicedNo ? nexpartItem?.supplierInvoicedNo : nexpartQoute?.paymentDetails?.billNumber || '',
                    cost: Number(nexpartItem.Mdse),
                    quantity: Number(nexpartItem.OrderQty),
                    usedQty: 0,
                    unUsedQty: 0,
                    qtyReturned: nexpartItem.qtyReturned,
                    totalCost: nexpartItem.cost * nexpartItem.quantity,
                    qtyAddedToInventory: nexpartItem.qtyAddedToInventory,
                    itemReturnQty: '' as string | number,
                    returnDate: new Date(),
                    itemSource: 'Nexpart',
                    isConsumed: false,
                    poNumber: nexpartQoute.poNumber,
                  };

                  item.subTotal = item.cost * item.quantity;
                  item.totalCost = item.subTotal;
                  item.isConsumed = item.quantity === item.qtyReturned;

                  this.totalOrderedQty += item.quantity;
                  this.orderedItems.push(item);

                  if (this.actualItem.isPopulateDynamically) {
                    const data = this.helperService.deepCopy(nexpartItem);
                    data.supplier = { name: order.Name };
                    data.orderItemId = nexpartItem.itemSourceId;

                    this.actualItem = this.formatItem(data, 'Nexpart');

                    if (this.dialogType === 'return') {
                      this.inventoryItem = this.actualItem;
                    }
                  }
                }
              });
            }
          });
        }
      });

      // speedDialQoutes
      speedDialQoutes.forEach((speedDial: any) => {
        if (speedDial?.quote?.order?.orderLines?.length) {
          speedDial?.quote?.order?.orderLines.forEach((speedDialItem: any) => {
            speedDialItem.itemSourceId = [speedDial.internalReferenceId, speedDialItem.productID, speedDialItem.brandID].join('-');

            if (speedDial.isOrderDelivered && speedDialItem.itemSourceId === this.actualItem.orderItemId && !speedDialItem.itemStatus) {
              speedDialItem.itemStatus = 'received';
            }
            if (speedDialItem.itemSourceId === this.actualItem.orderItemId && speedDialItem.itemStatus === 'received') {
              const item = {
                cartId: speedDial.internalReferenceId,
                orderItemId: speedDialItem.itemSourceId,
                type: 'part',
                title: speedDialItem.productDesc,
                description: speedDialItem.productDesc,
                code: speedDialItem.productID,
                productID: speedDialItem.productID,
                // isTaxable: this.adjustmentItem?.isTaxable || speedDialItem.isTaxable,
                isTaxable: false,
                price: Number(speedDialItem.listPrice),
                stocked: speedDialItem.stocked,
                supplier: speedDial.supplier,
                subTotal: 0,
                supplierInvoicedNo: speedDialItem?.supplierInvoicedNo ? speedDialItem?.supplierInvoicedNo : speedDial?.paymentDetails?.billNumber || '',
                cost: Number(speedDialItem.price),
                quantity: Number(speedDialItem.quantity),
                usedQty: 0,
                unUsedQty: 0,
                qtyReturned: speedDialItem.qtyReturned,
                totalCost: speedDialItem.cost * speedDialItem.quantity,
                qtyAddedToInventory: speedDialItem.qtyAddedToInventory,
                itemReturnQty: '' as string | number,
                returnDate: new Date(),
                itemSource: 'SpeedDial',
                isConsumed: false,
                poNumber: speedDial.poNumber,
              };

              item.subTotal = item.cost * item.quantity;
              item.totalCost = item.subTotal;
              item.isConsumed = item.quantity === item.qtyReturned;

              this.totalOrderedQty += item.quantity;
              this.orderedItems.push(item);

              if (this.actualItem.isPopulateDynamically) {
                const data = this.helperService.deepCopy(speedDialItem);
                data.supplier = speedDial.supplier;
                data.orderItemId = speedDialItem.itemSourceId;

                this.actualItem = this.formatItem(data, 'SpeedDial');

                if (this.dialogType === 'return') {
                  this.inventoryItem = this.actualItem;
                }
              }
            }
          });
        }
      });

      // PartsTech Qoutes
      partsTechQoutes.forEach((partsTechQoute: any) => {
        if (partsTechQoute.partsTechQoute && partsTechQoute.partsTechQoute.orders && partsTechQoute.partsTechQoute.orders.length) {
          partsTechQoute.partsTechQoute.orders.forEach((order: any) => {
            if (order.parts && order.parts.length) {
              order.parts.forEach((partsTechItem: any) => {
                if (partsTechQoute.isOrderDelivered && partsTechItem.orderItemId === this.actualItem.orderItemId && !partsTechItem.itemStatus) {
                  partsTechItem.itemStatus = 'received';
                }
                if (partsTechItem.orderItemId === this.actualItem.orderItemId && partsTechItem.itemStatus === 'received') {
                  const item: any = {
                    cartId: partsTechQoute.sessionId,
                    orderItemId: partsTechItem.orderItemId,
                    type: 'part',
                    title: partsTechItem.partName,
                    description: partsTechItem.description,
                    code: partsTechItem.partNumber,
                    // isTaxable: this.adjustmentItem?.isTaxable || partsTechItem.isTaxable,
                    isTaxable: false,
                    price: Number(partsTechItem.price.list),
                    stocked: partsTechItem.stocked,
                    supplier: { name: order.supplier && order.supplier.name },
                    subTotal: 0,
                    supplierInvoicedNo: partsTechItem?.supplierInvoicedNo ? partsTechItem?.supplierInvoicedNo : partsTechQoute.partsTechQoute?.paymentDetails?.billNumber || '',
                    cost: Number(partsTechItem.price.cost),
                    quantity: Number(partsTechItem.quantity),
                    usedQty: 0,
                    unUsedQty: 0,
                    qtyReturned: partsTechItem.qtyReturned,
                    totalCost: 0,
                    itemSourceId: partsTechItem.partId,
                    qtyAddedToInventory: partsTechItem.qtyAddedToInventory,
                    itemReturnQty: this.actualItem.isOpenFromServiceItem ? this.actualItem.count - this.actualItem.updateCount : ('' as string | number),
                    returnDate: new Date(),
                    itemSource: 'PartsTech',
                    isConsumed: false,
                    itemSelected: this.actualItem.isOpenFromServiceItem ? true : false,
                    size: '',
                    category: null,
                    model: '',
                    seasonality: '',
                    poNumber: order.poNumber,
                  };

                  if (this.actualItem.isOpenFromServiceItem) {
                    item.totalQtyStocked = this.actualItem.count - this.actualItem.updateCount;
                  }

                  if (partsTechItem.taxonomy && new RegExp('^tire*', 'i').test(partsTechItem.taxonomy.partTypeName)) {
                    item.type = 'tire';
                    item.size = partsTechItem.tireSize;
                    const [brand, ...model] = item.title.split(' ');
                    item.category = { name: brand };
                    item.model = model.join(' ');

                    if (partsTechItem.attributes && partsTechItem.attributes.length) {
                      item.description = partsTechItem.attributes.map(({ label, value }) => `${label}: ${value}`).join(', ');

                      const season = find(partsTechItem.attributes, { label: 'Category' });

                      if (season) {
                        if (new RegExp('all season', 'i').test(season.value)) item.seasonality = 'all';
                        else if (new RegExp('winter', 'i').test(season.value)) item.seasonality = 'winter';
                        else if (new RegExp('summer', 'i').test(season.value)) item.seasonality = 'summer';
                      }
                    }
                  }

                  item.subTotal = item.cost * item.quantity;
                  item.totalCost = item.subTotal;
                  item.isConsumed = item.quantity === item.qtyReturned;

                  this.totalOrderedQty += item.quantity;
                  this.orderedItems.push(item);

                  if (this.actualItem.isPopulateDynamically) {
                    const data = this.helperService.deepCopy(partsTechItem);

                    this.actualItem = this.formatItem(data, 'PartsTech');

                    if (this.dialogType === 'return') {
                      this.inventoryItem = this.actualItem;
                    }
                  }
                }
              });
            }
          });
        }
      });

      // TireHub Qoutes
      tireHubQoutes.forEach((tirehubQoute: any) => {
        if (tirehubQoute?.quote?.orders?.length) {
          tirehubQoute?.quote?.orders.forEach((order: any) => {
            if (order?.items?.length) {
              order?.items?.forEach((tireHubItem: any) => {
                if (tirehubQoute.isOrderDelivered && tireHubItem.orderItemId === this.actualItem.orderItemId && !tireHubItem.itemStatus) {
                  tireHubItem.itemStatus = 'received';
                }
                if (tireHubItem.orderItemId === this.actualItem.orderItemId && tireHubItem.itemStatus === 'received') {
                  const item = {
                    cartId: tirehubQoute.sessionId,
                    orderItemId: tireHubItem.orderItemId,
                    type: 'tire',
                    title: tireHubItem.title,
                    description: tireHubItem.description,
                    code: tireHubItem.code,
                    // isTaxable: this.adjustmentItem?.isTaxable || tireHubItem.isTaxable,
                    isTaxable: false,
                    price: Number(tireHubItem.price),
                    stocked: tireHubItem.stocked,
                    supplier: { name: tireHubItem?.warehouse?.name },
                    subTotal: 0,
                    supplierInvoicedNo: tireHubItem?.supplierInvoicedNo ? tireHubItem?.supplierInvoicedNo : tirehubQoute?.paymentDetails?.billNumber || '',
                    cost: Number(tireHubItem.unitPrice),
                    quantity: Number(tireHubItem.count),
                    usedQty: 0,
                    unUsedQty: 0,
                    qtyReturned: tireHubItem.qtyReturned,
                    totalCost: tireHubItem.unitPrice * tireHubItem.count,
                    qtyAddedToInventory: tireHubItem.qtyAddedToInventory,
                    itemReturnQty: '' as string | number,
                    returnDate: new Date(),
                    itemSource: 'TireHub',
                    isConsumed: false,
                    poNumber: tirehubQoute.poNumber,
                  };

                  item.subTotal = item.cost * item.quantity;
                  item.totalCost = item.subTotal;
                  item.isConsumed = item.quantity === item.qtyReturned;

                  this.totalOrderedQty += item.quantity;
                  this.orderedItems.push(item);

                  if (this.actualItem.isPopulateDynamically) {
                    const data = this.helperService.deepCopy(tireHubItem);
                    data.supplier = { name: order.Name };
                    data.orderItemId = tireHubItem.orderItemId;

                    this.actualItem = this.formatItem(data, 'TireHub');

                    if (this.dialogType === 'return') {
                      this.inventoryItem = this.actualItem;
                    }
                  }
                }
              });
            }
          });
        }
      });

      // TireConnect Qoutes
      tireConnectQoutes.forEach((tireConnectQoute: any) => {
        if (tireConnectQoute?.quote?.orders?.length) {
          tireConnectQoute?.quote?.orders.forEach((order: any) => {
            if (order?.items?.length) {
              order?.items?.forEach((tireConnectItem: any) => {
                if (tireConnectQoute.isOrderDelivered && tireConnectItem.orderItemId === this.actualItem.orderItemId && !tireConnectItem.itemStatus) {
                  tireConnectItem.itemStatus = 'received';
                }
                if (tireConnectItem.orderItemId === this.actualItem.orderItemId && tireConnectItem.itemStatus === 'received') {
                  const item = {
                    cartId: tireConnectQoute.sessionId,
                    orderItemId: tireConnectItem.orderItemId,
                    type: 'tire',
                    title: tireConnectItem.title,
                    description: tireConnectItem.description,
                    code: tireConnectItem.code,
                    // isTaxable: this.adjustmentItem?.isTaxable || tireConnectItem.isTaxable,
                    isTaxable: false,
                    price: Number(tireConnectItem.price),
                    stocked: tireConnectItem.stocked,
                    supplier: { name: tireConnectItem?.warehouse?.name },
                    subTotal: 0,
                    supplierInvoicedNo: tireConnectItem?.supplierInvoicedNo ? tireConnectItem?.supplierInvoicedNo : tireConnectQoute?.paymentDetails?.billNumber || '',
                    cost: Number(tireConnectItem?.unitPrice || tireConnectItem?.cost),
                    quantity: Number(tireConnectItem.count),
                    usedQty: 0,
                    unUsedQty: 0,
                    qtyReturned: tireConnectItem.qtyReturned,
                    totalCost: (tireConnectItem?.unitPrice || tireConnectItem?.cost) * tireConnectItem.count,
                    qtyAddedToInventory: tireConnectItem.qtyAddedToInventory,
                    itemReturnQty: '' as string | number,
                    returnDate: new Date(),
                    itemSource: 'TireConnect',
                    isConsumed: false,
                    poNumber: tireConnectQoute.poNumber,
                  };

                  item.subTotal = item.cost * item.quantity;
                  item.totalCost = item.subTotal;
                  item.isConsumed = item.quantity === item.qtyReturned;

                  this.totalOrderedQty += item.quantity;
                  this.orderedItems.push(item);

                  if (this.actualItem.isPopulateDynamically) {
                    const data = this.helperService.deepCopy(tireConnectItem);
                    data.supplier = { name: order.Name };
                    data.orderItemId = tireConnectItem.orderItemId;

                    this.actualItem = this.formatItem(data, 'TireConnect');

                    if (this.dialogType === 'return') {
                      this.inventoryItem = this.actualItem;
                    }
                  }
                }
              });
            }
          });
        }
      });

      // RepairLink Qoutes
      repairLinkQoutes.forEach((repairLinkQoute: any) => {
        if (repairLinkQoute?.quote?.orders?.length) {
          repairLinkQoute?.quote?.orders.forEach((order: any) => {
            if (order?.items?.length) {
              order?.items?.forEach((repairLinkItem: any) => {
                if (repairLinkQoute.isOrderDelivered && repairLinkItem.orderItemId === this.actualItem.orderItemId && !repairLinkItem.itemStatus) {
                  repairLinkItem.itemStatus = 'received';
                }
                if (repairLinkItem.orderItemId === this.actualItem.orderItemId && repairLinkItem.itemStatus === 'received') {
                  const item = {
                    cartId: repairLinkQoute.sessionId,
                    orderItemId: repairLinkItem.orderItemId,
                    type: 'part',
                    title: repairLinkItem.title,
                    description: repairLinkItem.description,
                    code: repairLinkItem.code,
                    // isTaxable: this.adjustmentItem?.isTaxable || repairLinkItem.isTaxable,
                    isTaxable: false,
                    price: Number(repairLinkItem.price),
                    stocked: repairLinkItem.stocked,
                    supplier: { name: order?.supplier?.name },
                    subTotal: 0,
                    supplierInvoicedNo: repairLinkItem?.supplierInvoicedNo ? repairLinkItem?.supplierInvoicedNo : repairLinkQoute?.paymentDetails?.billNumber || '',
                    cost: Number(repairLinkItem.cost),
                    quantity: Number(repairLinkItem.count),
                    usedQty: 0,
                    unUsedQty: 0,
                    qtyReturned: repairLinkItem.qtyReturned,
                    totalCost: repairLinkItem.cost * repairLinkItem.count,
                    qtyAddedToInventory: repairLinkItem.qtyAddedToInventory,
                    itemReturnQty: '' as string | number,
                    returnDate: new Date(),
                    itemSource: 'RepairLink',
                    isConsumed: false,
                    poNumber: repairLinkQoute.poNumber,
                  };

                  item.subTotal = item.cost * item.quantity;
                  item.totalCost = item.subTotal;
                  item.isConsumed = item.quantity === item.qtyReturned;

                  this.totalOrderedQty += item.quantity;
                  this.orderedItems.push(item);

                  if (this.actualItem.isPopulateDynamically) {
                    const data = this.helperService.deepCopy(repairLinkItem);
                    data.supplier = { name: order.Name };
                    data.orderItemId = repairLinkItem.orderItemId;

                    this.actualItem = this.formatItem(data, 'RepairLink');

                    if (this.dialogType === 'return') {
                      this.inventoryItem = this.actualItem;
                    }
                  }
                }
              });
            }
          });
        }
      });

      if (this.orderedItems.length === 1 && !this.orderedItems[0]?.isConsumed) {
        this.handleChange('selected', this.orderedItems[0], true);
      }

      this.orderCode = order.code;
      this.orderStatus = order.orderStatus;
    } catch (err) {
      console.log(err);
      this.helperService.showToaster('error', err);
    } finally {
      this.isLoading = false;
    }
  }

  formatData() {
    const orderedItems = [];

    this.orderedItems.forEach((orderedItem: any) => {
      if (orderedItem.selected) {
        const data = this.helperService.deepCopy(this.actualItem);

        data.orderId = this.orderId;
        data.orderCode = this.orderCode;
        data.cartId = orderedItem.cartId;
        data.orderItemId = orderedItem.orderItemId;
        data.itemSource = orderedItem.itemSource;
        data.itemReturnQty = Number(orderedItem.itemReturnQty || 0);
        data.totalQtyStocked = Number(orderedItem.totalQtyStocked || 0);
        data.supplierInvoiceNo = orderedItem.supplierInvoicedNo;
        data.supplier = orderedItem.supplier;
        data.qtyOrdered = orderedItem.quantity;
        data.cost = orderedItem.cost;
        data.isTaxable = orderedItem.isTaxable;
        data.productID = orderedItem.productID;

        if (this.dialogType === 'inventory') {
          data.stockItemId = this.inventoryItem._id;
        }

        if (data.itemSource === 'ManualOrder') {
          data.orderServiceItemId = orderedItem.orderItemId;
        }

        if (orderedItem.returnDate) {
          data.itemReturnDate = this.dateService.formatDate(orderedItem.returnDate, datetimeFormat.yyymmdd);
        }

        orderedItems.push(data);
      }
    });

    return {
      orderedItems,
      orderId: this.orderId,
      stockItemId: this.inventoryItem._id,
      orderServiceItemId: this.actualItem._id,
      location: this.inventoryItem.locations && this.inventoryItem.locations[0],
    };
  }

  formatItem(orderedItem: any, itemSource: string) {
    const item: any = {
      isTaxable: false,
      displayDescOnOrder: false,
      displayHoursOnOrder: false,
      discount: { value: 0, type: 'percentage', name: 'Percent' },
    };

    if (itemSource === 'Nexpart') {
      orderedItem.quantity = Number(orderedItem.OrderQty);
      orderedItem.supplier = { name: orderedItem.supplier.name };
      orderedItem.partName = orderedItem.SellerPartDesc;
      orderedItem.partNumber = orderedItem.PartNumber;
      orderedItem.description = orderedItem.CatalogPartDesc;
      orderedItem.orderItemId = orderedItem.orderItemId;
      orderedItem.partId = orderedItem.PartNumber;
      orderedItem.lineCardId = orderedItem.LineCode;
      orderedItem.itemSource = 'Nexpart';
      orderedItem.price = {
        list: Number(orderedItem.List),
        price: Number(orderedItem.List),
        cost: Number(orderedItem.Mdse),
        core: Number(orderedItem.Core),
        costWithCore: Number(orderedItem.Mdse) + Number(orderedItem.Core),
      };
      orderedItem.amount = orderedItem.quantity * orderedItem.price.cost;
    }

    if (itemSource === 'SpeedDial') {
      orderedItem.quantity = Number(orderedItem.quantity);
      orderedItem.supplier = { name: orderedItem.supplier.name };
      orderedItem.partName = orderedItem.productDesc;
      orderedItem.partNumber = orderedItem.productID;
      orderedItem.description = orderedItem.productDesc;
      orderedItem.orderItemId = orderedItem.orderItemId;
      orderedItem.partId = orderedItem.productID;
      orderedItem.productID = orderedItem.productID;
      orderedItem.lineCardId = orderedItem.LineCode;
      orderedItem.itemSource = 'SpeedDial';
      orderedItem.price = {
        list: Number(orderedItem.listPrice),
        price: Number(orderedItem.listPrice),
        cost: Number(orderedItem.price),
        core: Number(orderedItem.corePrice),
        quantity: Number(orderedItem.quantity),
        costWithCore: Number(orderedItem.price) + Number(orderedItem.corePrice)
      };
      orderedItem.amount = orderedItem.quantity * orderedItem.price.cost;
    }

    if (['TireHub', 'TireConnect'].includes(itemSource)) {
      orderedItem.partName = [orderedItem.brand, orderedItem.model].filter((str) => str).join(' ');
      orderedItem.quantity = Number(orderedItem.count);
      orderedItem.supplier = { name: orderedItem?.warehouse?.name };
      orderedItem.partNumber = orderedItem.partNumber;
      orderedItem.description = orderedItem.description;
      orderedItem.orderItemId = orderedItem.orderItemId;
      orderedItem.partId = orderedItem.orderItemId;
      orderedItem.lineCardId = orderedItem.orderItemId;
      orderedItem.tireSize = orderedItem.size;
      orderedItem.itemSource = itemSource;
      orderedItem.price = {
        list: Number(orderedItem.price),
        price: Number(orderedItem.price),
        cost: Number(orderedItem.price),
        core: Number(0),
        costWithCore: Number(0) + Number(0),
      };
      orderedItem.amount = orderedItem.quantity * orderedItem.price.cost;
    }

    if (itemSource === 'RepairLink') {
      orderedItem.partName = orderedItem.title;
      orderedItem.quantity = Number(orderedItem.count);
      orderedItem.supplier = { name: orderedItem?.supplier?.name };
      orderedItem.partNumber = orderedItem.partNumber;
      orderedItem.description = orderedItem.description;
      orderedItem.orderItemId = orderedItem.orderItemId;
      orderedItem.partId = orderedItem.orderItemId;
      orderedItem.lineCardId = orderedItem.orderItemId;
      orderedItem.itemSource = itemSource;
      orderedItem.price = {
        list: Number(orderedItem.price),
        price: Number(orderedItem.price),
        cost: Number(orderedItem.cost),
        core: Number(orderedItem.core),
        costWithCore: Number(orderedItem.cost) + Number(orderedItem.core),
      };
      orderedItem.amount = orderedItem.quantity * orderedItem.price.cost;
    }

    item.type = 'part';
    item.code = orderedItem.partNumber;
    item.title = orderedItem.partName;
    item.description = orderedItem.description || orderedItem.partNumber || '';
    item.itemSource = orderedItem.itemSource;
    item.poNumber = orderedItem.poNumber;
    item.code = orderedItem.partNumber;
    item.supplier = orderedItem.supplier;
    item.count = orderedItem.quantity;
    item.price = orderedItem.price.list;
    item.cost = orderedItem.price.cost;
    item.actualCost = orderedItem.price.cost;
    item.coreCost = orderedItem.price.core;
    item.partOrderId = orderedItem.id;
    item.orderItemId = orderedItem.orderItemId;
    item.lineCartId = orderedItem.lineCardId;
    item.itemSourceId = orderedItem.partId;
    item.subTotal = item.price * item.count;

    if (['TireHub', 'TireConnect'].includes(orderedItem.itemSource) || orderedItem?.taxonomy?.partTypeName === 'Tire') {
      const [brand, ...model] = item.title.split(' ');

      item.type = 'tire';
      item.size = orderedItem.tireSize;
      item.category = { name: brand };
      item.model = model.join(' ');

      if (orderedItem.attributes?.length) {
        item.description = orderedItem.attributes.map(({ label, value }) => `${label}: ${value}`).join(', ');

        const season = find(orderedItem.attributes, { label: 'Category' });

        if (season) {
          if (new RegExp('all season', 'i').test(season.value)) item.seasonality = 'all';
          else if (new RegExp('winter', 'i').test(season.value)) item.seasonality = 'winter';
          else if (new RegExp('summer', 'i').test(season.value)) item.seasonality = 'summer';
        }
      }
    }

    return item;
  }

  handleChange(key: string, orderedItem: any, value: any) {
    orderedItem[key] = value;
  }

  handleClose(isSuccess: boolean = false, data: any = null) {
    this.dynamicDialogRef.close({ isSuccess, data });

    if (isSuccess) {
      this.dataService.sendData(this.dataService.typePassData('unused-list', {}));
    }
  }

  handleValidate() {
    let isValid = true;
    let isQtyAdded = true;
    let totalQtyStocked = 0;
    let totalQtyReturned = 0;
    let totalQtyUsedNow = 0;

    let roundOff = this.calculateService.roundOff;
    this.orderedItems.forEach((orderItem) => {
      if (orderItem.selected) {
        const availableQty = roundOff(orderItem.quantity) - (roundOff(orderItem.qtyAddedToInventory) + roundOff(orderItem.qtyReturned));

        totalQtyReturned += roundOff(orderItem.qtyReturned || 0);
        totalQtyStocked += roundOff(orderItem.qtyAddedToInventory || 0);
        totalQtyUsedNow += this.dialogType === 'return' ? roundOff(orderItem.itemReturnQty) : roundOff(orderItem.totalQtyStocked);

        // 1st check value added
        if (!orderItem.totalQtyStocked && this.dialogType === 'inventory') {
          orderItem.qtyAddedToInventoryIsInvalid = true;
           orderItem.qtyAddedToInventoryError = `Add quantity`;
          isQtyAdded = false;
          return
        } else if (!orderItem.itemReturnQty && this.dialogType === 'return') {
          orderItem.qtyReturnedIsInvalid = true;
           orderItem.qtyReturnedError = `Add quantity`;
          isQtyAdded = false;
          return
        }

        if (this.dialogType === 'return' && roundOff(availableQty) < roundOff(orderItem.itemReturnQty)) {
          orderItem.qtyReturnedError = `Qty can't be greater than ${availableQty}`;
          orderItem.qtyReturnedIsInvalid = true;
          isValid = false;
        } else if (this.dialogType === 'return' && !Number.isInteger(Number(orderItem.itemReturnQty || 0))) {
          orderItem.qtyReturnedError = 'Decimal values are not allowed';
          orderItem.qtyReturnedIsInvalid = true;
          isValid = false;
        } else {
          orderItem.qtyReturnedError = '';
          orderItem.qtyReturnedIsInvalid = false;
        }

        if (this.dialogType === 'inventory' && roundOff(availableQty) < roundOff(orderItem.totalQtyStocked)) {
          orderItem.qtyAddedToInventoryError = `Qty can't be greater than ${availableQty}`;
          orderItem.qtyAddedToInventoryIsInvalid = true;
          isValid = false;
        } else {
          orderItem.qtyAddedToInventoryError = '';
          orderItem.qtyAddedToInventoryIsInvalid = false;
        }
      }
    });
    // Adding a fix for ALP-12655
    // In case of order status to invoice actual item count is added and ultimately the qty consumed becomes greater than total available quantity
    //const qtyConsumed = totalQtyReturned + totalQtyStocked + totalQtyUsedNow + (this.orderStatus === 'estimate' ? 0 : this.actualItem.count);
    const qtyConsumed = totalQtyReturned + totalQtyStocked + totalQtyUsedNow;

    if (roundOff(this.totalOrderedQty) < roundOff(qtyConsumed)) {
      isValid = false;
    }

    this.orderedItems.forEach((orderItem) => {
      if (orderItem.selected) {
        orderItem.qtyAddedToInventoryIsInvalid = !isValid || !isQtyAdded;
        orderItem.qtyReturnedIsInvalid = !isValid || !isQtyAdded;
      }
    });

    if (!isValid) {
      const msg = `You are adding more than available unused qty of item to add to inventory, please reduce it and try again`;
      this.helperService.showToaster('error', msg);
    } else if(!isQtyAdded) {
      isValid = false;
    }

    const consumedItems = this.orderedItems?.filter((orderItem: any) => orderItem?.isConsumed) || [];

    if (isValid && this.dialogType === 'return' && consumedItems?.length && consumedItems?.length === this.orderedItems?.length) {
      isValid = false;
      this.helperService.showToaster('error', 'All the ordered item has already been returned');
    }

    return isValid;
  }

  handleSubmit() {
    if (!this.handleValidate() || this.isSaving) return;

    this.isSaving = true;

    if (this.dialogType === 'return') {
      this.handleSaveReturn();
    } else {
      this.handleSaveInventory();
    }
  }

  openReturnedQtyConfirmationDialog(isInventory = false) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '50%',
      styleClass: 'small-heading-dialog parts-ordering',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
        headerIconType: 'header-icon-warning',
        isHTML: true,
        type: 'Confirm',
        styleClassHeading: 'font-18 font-700',
        styleClassCloseIcon: 'font-24 font-400 font-gray',
        headerIcon: 'fal fa-exclamation-triangle font-icon-warning',
        title: 'Insufficient Quantity Available',
        message: `
        <span class="font-12">
        The quantity you've entered exceeds the unused quantity. Since the RO is finalized, returning the item will not impact the quantity on the service line. Please create an adjustment invoice to adjust the quantity on the service line.
        </span>`,
        button: {
          success: {
            title: 'Proceed Anyway',
            backgroundColor: '#D47877',
          },
          cancel: { title: 'Create Adjustment Invoice' },
        },
      },
    });

    const onCloseConfirmationDialog = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        this.isSaving = true;
        if (isInventory) this.handleSaveInventory(true);
        else this.handleSaveReturn(true);
      } else {
        if (close.data.btn === 'cancel') {
          this.createAdjustmentInvoice(this.adjustmentItem);
          this.handleClose(false);
        }
      }

      onCloseConfirmationDialog.unsubscribe();
    });
  }

  async handleSaveReturn(forceUpdate = false) {
    try {
      const returnPayload: any = this.formatData();
      if (forceUpdate) returnPayload.forceUpdate = true;
      const data: any = await this.httpService.addUpdateOrderReturn(returnPayload);
      // const data = {msg: true}
      if (data.msg) {
        this.adjustmentItem.quantity = data.unUsedQty && data.unUsedQty > 0 ? data.unUsedQty : data.actionQty;
        this.openReturnedQtyConfirmationDialog();
      } else {
        this.handleClose(true, data);
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isSaving = false;
    }
  }

  async handleSaveInventory(forceUpdate = false) {
    try {
      const returnPayload: any = this.formatData();
      if(this.orderedItems?.length) {
        returnPayload.poNumber = this.orderedItems[0]?.poNumber;
      }
      if (forceUpdate) returnPayload.forceUpdate = true;
      const data: any = await this.httpService.addUpdateOrderedInventory(returnPayload);

      if (data.msg) {
        this.adjustmentItem.quantity = data.unUsedQty && data.unUsedQty > 0 ? data.unUsedQty : data.actionQty;
        this.openReturnedQtyConfirmationDialog(true);
      } else {
        this.handleClose(true, data);
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isSaving = false;
    }
  }

  createAdjustmentInvoice(item) {
    const order = {
      invoiceType: 'refund',
      browserSessionId: Date.now(),
      adjustmentsForInvoiceId: this.estimate._id,
      customer: { customerId: this.estimate.customer.customerId },
      vehicle: null,
    };

    if (this.estimate.vehicle?.vehicleId) {
      order.vehicle = { vehicleId: this.estimate.vehicle.vehicleId };
    }

    // this.isCreatingAdjustments = true;
    this.httpService
      .createRepairOrder(order)
      .then(
        (order) => {
          const queryParams: any = {
            browserSessionToken: order.restriction.token || '',
            checkPreferredLocation: order.checkPreferredLocation || false,
            itemId: item.orderItemId,
            itemQty: this.adjustmentItem.quantity,
          };
          
          const url = this.helperService.constructQueryParams(`/estimate/${order._id}`, queryParams);
          this.helperService.openPageInNewExistingTab(url, order._id);
          if (this.dataService.isGainSightPXEnabled) {
            const estimateCreated: any = {
              roCreationSource: 'Adjustment invoice',
              roNumber: order.code || '',
            };

            this.helperService.postGainsightPXEvent('RO Created', estimateCreated);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        // this.isCreatingAdjustments = false;
      });
  }
}
